import { Component, HostListener, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-criar-pergunta-modal',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './criar-pergunta-modal.component.html',
  styleUrl: './criar-pergunta-modal.component.scss',
})
export class CriarPerguntaModalComponent {
  readonly form = input.required<FormGroup>();
  readonly submitAttempted = input(false);

  readonly cancelar = output<void>();
  readonly criar = output<void>();

  onCancelar(): void {
    this.cancelar.emit();
  }

  onCriar(): void {
    this.criar.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.onCancelar();
  }
}
